import React, { useState } from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { Button } from "evergreen-ui";
import { Form, Input, Select, message } from "antd";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref, update } from "firebase/database";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";
import { useListVals } from "../../../Firebase/databaseHooks";
import { describeImportSummary, importTranslationFile } from "../../../utils/translationSheets";

const { TextArea } = Input;
var db = getDatabase(Firebase);

const LangEditLayout = (props) => {
	const [showLoading, setShowLoading] = useState(false);
	const canUpdate = props.canUpdate !== false;
	const [file, setFile] = useState(null);
	const [uiStrings] = useListVals(ref(db, "talmidsdb/uiStrings"));

	const handleEdit = (values) => {
		if (!canUpdate) {
			message.error("You do not have permission to update languages.");
			return;
		}

		setShowLoading(true);

		var language = {
			"languageName": values?.languageName,
			"status": values?.status,
		};

		update(ref(db, "talmidsdb/languages/" + props?.langItem.id), language)
			.then(() => {
				if (!file) return;
				// Optional re-upload of a filled-in translation sheet.
				return importTranslationFile(file, {
					uiStrings,
					language: { ...props?.langItem, ...language },
					languageId: props?.langItem.id,
				}).then((summary) => {
					const text = describeImportSummary(summary);
					if (summary.error || summary.updated === 0) {
						message.warning(text, 8);
					} else {
						message.success(text, 8);
					}
				});
			})
			.then(() => {
				setShowLoading(false);
				message.success("Language Updated");
				props?.callback("true");
			})
			.catch((error) => {
				setShowLoading(false);
				alert("Unable to update : " + error);
			})
	}

	return (
		<div className="font-Nunito">
			<MDBRow className="p-3">
				<Form
					layout={"vertical"}
					className="w-100"
					onFinish={handleEdit}
					initialValues={{
						languageName: props?.langItem?.languageName,
						status: props?.langItem?.status
					}}
				>
					<Form.Item label="Language Name" name="languageName">
						<Input
							type="text"
							size={"large"}
							style={{ width: "100%" }}
							id="languageName"
							placeholder="enter language name"
							disabled={!canUpdate}
						/>
					</Form.Item>

					<Form.Item label="Status" name="status">
						<Select
							size={"large"}
							placeholder="Select lesson status"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}
							disabled={!canUpdate}
						>
							{[
								{ label: "Active" },
								{ label: "In-Progress" },
								{ label: "Inactive" }
							].map((item, index) => (
								<Select.Option value={item.label}>{item.label}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Import Translations"
						extra="Optional. A sheet exported from the Languages list (Key | English | Translation).">
						<Input
							type="file"
							accept=".xlsx, .xls, .csv"
							size="large"
							disabled={!canUpdate}
							onChange={(e) => setFile(e.target.files?.[0] || null)}
						/>
					</Form.Item>
					<Button
						isLoading={showLoading}
						appearance="primary"
						className="mt-1"
						htmlType="submit"
						disabled={!canUpdate}
					>
						Submit
					</Button>
				</Form>
			</MDBRow>
		</div>
	);
};

export default LangEditLayout;
